import { createContext, useContext } from "react";
import { ServiceRegistrationRequirementDto } from "../../types/types";

export enum PartyFormMode {
  Admin = "Admin",
  PublicRegistration = "PublicRegistration",
  ProfileCompletion = "ProfileCompletion",
}

export type PartyType = "Person" | "Family" | "Organisation";

export interface PartyFormContextValue {
  mode: PartyFormMode;
  partyType?: PartyType;
  serviceId?: number;
  serviceName?: string;
  invitationToken?: string;
  readOnly?: boolean;
  allowPartySearch: boolean;
  allowMerge: boolean;
  allowDelete: boolean;
  allowPartyTypeChange: boolean;
  allowServiceSelection: boolean;
  allowViewInternalIds: boolean;
  allowNavigation: boolean;
  registrationRequirements?: ServiceRegistrationRequirementDto[];
  agreementResponses?: Array<{
    serviceAgreementTemplateId: number;
    accepted: boolean | null;
  }>;
}

export const adminPartyFormContext: PartyFormContextValue = {
  mode: PartyFormMode.Admin,
  allowPartySearch: true,
  allowMerge: true,
  allowDelete: true,
  allowPartyTypeChange: true,
  allowServiceSelection: true,
  allowViewInternalIds: true,
  allowNavigation: true,
};

const PartyFormContext = createContext<PartyFormContextValue>(
  adminPartyFormContext,
);

export const PartyFormProvider = PartyFormContext.Provider;
export const usePartyFormContext = () => useContext(PartyFormContext);
